import { useEffect } from 'react'
import { serverConfig } from '@/config/server.config'

const CLARITY_SCRIPT_ID = 'microsoft-clarity'

export function ClarityLoader() {
  useEffect(() => {
    if (!serverConfig.clarityProjectId) {
      return
    }

    if (document.getElementById(CLARITY_SCRIPT_ID)) {
      return
    }

    const script = document.createElement('script')
    script.id = CLARITY_SCRIPT_ID
    script.type = 'text/javascript'
    script.text = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","${serverConfig.clarityProjectId}");`

    document.head.appendChild(script)
  }, [])

  return null
}
